import { action, flow, observable, runInAction, toJS } from 'mobx';
import Consent from '../../Consent';
import API from '../../../api/index';
import { rootStore } from 'stores/RootStore';

export default class ConsentSignature {
	items: Array<Consent> = [];

	@observable isSigned: boolean = false;
	@observable isLoading: boolean = true;

	extend(data: ConsentSignature = {}) {
		runInAction(() => {
			Object.assign(this, data);
		});
	}

	@action
	load() {
		if (!this.isLoading) {
			return;
		}
		let user = rootStore.auth.user;
		if (!user) {
			return;
		}
		return API.get(`/ConsentSignatures/allUnsignedConsentsForUser/${user.id}`)
			.then(result => {
				this.items = result.map(el => new Consent(el));
				this.isSigned = this.items.length === 0;
				this.isLoading = false;
			})
			.catch(err => {
				console.log(err);
			});
	}

	@action
	signAllConsents = flow(function*() {
		let user = rootStore.auth.user;
		yield API.post(`/ConsentSignatures/signConsentsForUser/${user.id}`, toJS(this));
		this.isSigned = true;
	});

	@action
	clear() {
		this.items = [];
		this.isSigned = false;
		this.isLoading = true;
	}
}



// WEBPACK FOOTER //
// ./src/stores/ui/manager/ConsentSignature.js